// 服务生态
<template>
  <div>
	<el-row type="flex" justify="center" class="customFadeInDown delay-0-1s slow">
		<el-col :span="24">
			<el-row><el-image :src="banner"></el-image></el-row>
		</el-col>
	</el-row>
    <el-row type="flex" justify="center" class="product_content">
      <el-col :span="24">
        <el-row class="product_title" style="font-size:36px;color:#0b0b0b;">智能云产品</el-row>
        <el-row class="font-small" style="font-size:16px;">我们为您提供丰富、安全、易用、灵活的智能云产品，</el-row>
        <el-row class="font-small" style="font-size:16px;">满足您的一切服务所需。</el-row>
        <el-row class="product_list">
          <el-col :span="6" :offset="6">
            <el-row class="product_list_title">智能客服</el-row>
            <el-row class="product_list_content">用一个通用的平台连接包括电话、在线客服、手机app、微信网页表单在内的所有渠道，帮助各种行业不同规模的企业向客户提供最便捷的服务。</el-row>
            <el-row justify="left" type="flex" style="padding-top:10px;"><el-button size="small" type="primary" @click="contact">咨询 > ></el-button></el-row>
          </el-col>
        </el-row>
        <el-row class="product_list">
          <el-col :span="6" :offset="12">
            <el-row class="product_list_title">语音云网关</el-row>
            <el-row class="product_list_content">用一个通用的平台连接包括电话、在线客服、手机app、微信网页表单在内的所有渠道，帮助各种行业不同规模的企业向客户提供最便捷的服务。</el-row>
          </el-col>
        </el-row>
        <el-row class="product_list">
          <el-col :span="6" :offset="6">
            <el-row class="product_list_title">云会议</el-row>
            <el-row class="product_list_content">高清流畅的音视频、快速的数据共享、多种互动交流方式、和电话邀请参会的功能，您只需通过电脑或手机登录后，即可快速地与全球各地团队进行实时音视频沟通。</el-row>
          </el-col>
        </el-row>
        <el-row class="product_list">
          <el-col :span="6" :offset="12">
            <el-row class="product_list_title">智能机器人</el-row>
            <el-row class="product_list_content">多维度的知识库体系，24*7小时永不离线，自动解决80%的常见问题。与人工客服的无缝结合，更加提高了工作效率和客户满意度。</el-row>
          </el-col>
        </el-row>
        <el-row class="product_list" style="padding-bottom:100px;">
          <el-col :span="6" :offset="6">
            <el-row class="product_list_title">大数据</el-row>
            <el-row class="product_list_content">完善的生态体系，是企业大数据营销的核心利器。包括AMCC全媒体呼叫中心、IMS智能数据管理系统、MAFS经分与决策系统。</el-row>
            <el-row justify="left" type="flex" style="padding-top:10px;"><el-button size="small" type="primary" @click="contact">咨询 > ></el-button></el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" class="waihu_content">
      <el-col :span="24">
        <el-row class="product_title" style="font-size:36px;color:#0b0b0b;">智能云外呼平台</el-row>
        <el-row class="font-small" style="font-size:16px;">拨打、记录、数据分析、智能学习全流程自动化服务，</el-row>
        <el-row class="font-small" style="font-size:16px;">全面提高话务产能，提升外呼效率。</el-row>
        <el-row style="margin-top:80px;">
          <el-col :span="5" :offset="11" class="waihu_list">
            <el-row class="waihu_list_title">智能拨打</el-row>
            <el-row class="waihu_list_content">批量导入数据，根据需求设置拨打时间和频率，自动外呼更省时省力。</el-row>
          </el-col>
          <el-col :span="4" :offset="1" class="waihu_list">
            <el-row class="waihu_list_title">智能应答</el-row>
            <el-row class="waihu_list_content">语音智能识别、合成与分析技术支持，让人机交互过程更流畅自然。</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px;">
          <el-col :span="5" :offset="11" class="waihu_list">
            <el-row class="waihu_list_title">客户分析</el-row>
            <el-row class="waihu_list_content">大数据用户画像，精准锁定目标客户，提高营销转化率。</el-row>
          </el-col>
          <el-col :span="4" :offset="1" class="waihu_list">
            <el-row class="waihu_list_title">通话录音</el-row>
            <el-row class="waihu_list_content">通话录音、语音转文字、话者分离，人工查看更方便。</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px;">
          <el-col :span="5" :offset="11" class="waihu_list">
            <el-row class="waihu_list_title">数据分析</el-row>
            <el-row class="waihu_list_content">通话、在线、工单等全平台数据统计分析，企业管理更清晰。</el-row>
          </el-col>
          <el-col :span="4" :offset="1" class="waihu_list">
            <el-row class="waihu_list_title">智能学习</el-row>
            <el-row class="waihu_list_content">机器人将客户问题自主学习进知识库，随着交互数据自动更新维护。</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px;">
          <el-col :span="5" :offset="11">
            <el-button size="small" type="primary" @click="contact">咨询 > ></el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" class="mahao_content">
      <el-col :span="24">
        <el-row class="product_title" style="font-size:36px;color:#0b0b0b;">线路码号</el-row>
        <el-row class="font-small" style="font-size:16px;">号码资源丰富，全网运营商线路接入，优质的线路资源，稳定可靠。</el-row>
        <el-row style="margin-top:40px;">
          <el-col :span="5" :offset="5" class="waihu_list">
            <el-row class="waihu_list_title">号码资源丰富</el-row>
            <el-row class="waihu_list_content">丰富的全国号码资源，与平台对接即可快速开通全国号码数据，执行外呼任务，呼出更灵活。</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px;">
          <el-col :span="5" :offset="5" class="waihu_list">
            <el-row class="waihu_list_title">优质线路资源</el-row>
            <el-row class="waihu_list_content">全网运营商线路接入，优质线路，无并发上限，带来清晰稳定的通话效果。</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:80px;">
          <el-col :span="5" :offset="11">
            <el-button size="small" type="primary" @click="contact">咨询 > ></el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
	
	<el-row type="flex" justify="center" class="monitor_content">
	  <el-col :span="24">
	    <el-row class="product_title" style="font-size:36px;color:#0b0b0b;">质量监控平台</el-row>
	    <el-row class="font-small" style="font-size:16px;">设计完善的质量测评体系；AI智能化质检工具；实时指标监控体系；报表数据分析系统</el-row>
	    <el-row style="margin-top:80px;">
	      <el-col :span="5" :offset="11" class="waihu_list">
	        <el-row class="waihu_list_title">质量测评体系</el-row>
	        <el-row class="waihu_list_content">通过分类建立上线前的测评体系，实现对方案内容的精确评估；通过对影响产品服务质量维度的综合分析，建立产品服务健康度的评估模型。</el-row>
	      </el-col>
	      <el-col :span="4" :offset="1" class="waihu_list">
	        <el-row class="waihu_list_title">智能质检</el-row>
	        <el-row class="waihu_list_content">覆盖人工客服和客户的每一句对话，采用智能自动质检+人工审核的方式，辅助提升在线人工客服系统的服务质量和工作效率，对人工客服工作作出全面、准确的量化评价。</el-row>
	      </el-col>
	    </el-row>
	    <el-row style="margin-top:40px;">
	      <el-col :span="5" :offset="11" class="waihu_list">
	        <el-row class="waihu_list_title">指标监控</el-row>
	        <el-row class="waihu_list_content">过程监控和指标监控，分别对人工客服的服务规范和服务内容，以及呼叫中心设定好的例如接通率、及时率、外呼营销成功率、投诉率等指标进行监控。</el-row>
	      </el-col>
	      <el-col :span="4" :offset="1" class="waihu_list">
	        <el-row class="waihu_list_title">数据分析</el-row>
	        <el-row class="waihu_list_content">支持快速创建数据分析模板，数据类型支持接口方式和批量导入等，可区分不同项目得多维度查询并自定义导出数据报表。</el-row>
	      </el-col>
	    </el-row>
	    <el-row style="margin-top:40px;">
	      <el-col :span="5" :offset="11">
	        <el-button size="small" type="primary" @click="monitorDetail">详情 > ></el-button>
	      </el-col>
	    </el-row>
	  </el-col>
	</el-row>

    <el-row type="flex" justify="center" class="yuyin_content">
      <el-col :span="24">
        <el-row class="product_title" style="padding-top:50px;color:white;font-size:36px;">云语音平台</el-row>
        <el-row class="font-small" style="color:#EBEEF5;font-size:16px;">智能云语音服务，灵活对接各种业务场景。</el-row>
        <el-row style="margin-top: 300px;margin-bottom:60px;">
          <el-col :span="7" :offset="3" class="yuyin_list_1">
            <el-row class="waihu_list_title" style="color:white;">云语音识别系统</el-row>
            <el-row class="waihu_list_content" style="color:#EBEEF5;">将语音和视频资源转化为文字，再结合具体业务需求，梳理为结构化数据</el-row>
          </el-col>
          <el-col :span="7" :offset="3" class="yuyin_list_2">
            <el-row class="waihu_list_title" style="color:white;">云语音合成系统</el-row>
            <el-row class="waihu_list_content" style="color:#EBEEF5;">将任意行业领域的文本高效准确的转化为清晰流畅的自然语音，开启人机交互全新体验</el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top:40px;margin-bottom:60px;">
          <el-col :span="7" :offset="3" class="yuyin_list_3">
            <el-row class="waihu_list_title" style="color:white;">云语音分析系统</el-row>
            <el-row class="waihu_list_content" style="color:#EBEEF5;">将呼叫中心巨量非结构化录音数据转为文字，同时保留相关声学参数，自动区分坐席和客户</el-row>
          </el-col>
          <el-col :span="7" :offset="3" class="yuyin_list_4">
            <el-row class="waihu_list_title" style="color:white;">云语音交互系统</el-row>
            <el-row class="waihu_list_content" style="color:#EBEEF5;">通过高性能的语音识别、合成、分析，理解用户意图，响应用户需求</el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
	import connect from '@/util/connect.js'
  export default {
    data() {
      return {
        banner:require("../../assets/ecology/banner_new.png"),
      }
    },
    mounted() {},
    computed: {},
    methods: {
		contact(){document.getElementById("nb_invite_ok").click();},
		monitorDetail(){
			this.$router.push("/ecology/monitor")
		}
	}
  }
</script>

<style scoped>
	@import "../../assets/css/animation.css";
.product_content{
  background: url("../../assets/ecology/product_bg.png") no-repeat;
  background-position: 50% 6%;
}
.product_title{
  font-size: 26px;
  font-weight: bold;
  padding: 35px 0px 15px 0px;
}
.product_list_title{
  text-align:left;
  font-weight:bold;
  font-size:20px;
  padding:35px 0px 15px 0px;
}
.product_list_content{
  text-align:left;
  font-size:12px;
  line-height:18px;
}
.product_list{
  padding-top:200px;
}
.waihu_content{
  background: url("../../assets/ecology/waihu_bg.png") no-repeat;
  background-position: 50% 20%;
  padding-bottom:40px;
}
.monitor_content{
  background: url("../../assets/ecology/monitor_bg.png") no-repeat;
  background-position: 0% -35%;
  padding-bottom:40px;
}
.waihu_list{
  padding:2px 2px 2px 20px;
  background: url("../../assets/ecology/waihu_list_bg.png") no-repeat;
  background-position-y: 9px;
}
.waihu_list_title{
  text-align:left;
  font-weight:bold;
  font-size:18px;
  padding-bottom:15px;
}
.waihu_list_content{
  text-align:left;
  font-size:14px;
  line-height:20px;
}
.mahao_content{
  background: url("../../assets/ecology/mahao_bg.png") no-repeat;
  background-position: 50% 40%;
}
.yuyin_content{
  background: url("../../assets/ecology/yuyin_bg.png") no-repeat;
  background-position: 50% 25%;
  margin-top:50px;
}
.yuyin_list_1{
  padding: 12px 2px 34px 140px;
  background: url("../../assets/ecology/yuyin_list_1_bg.png") no-repeat;
}
.yuyin_list_2{
  padding: 12px 2px 34px 140px;
  background: url("../../assets/ecology/yuyin_list_2_bg.png") no-repeat;
}
.yuyin_list_3{
  padding: 12px 2px 34px 140px;
  background: url("../../assets/ecology/yuyin_list_3_bg.png") no-repeat;
}
.yuyin_list_4{
  padding: 12px 2px 34px 140px;
  background: url("../../assets/ecology/yuyin_list_4_bg.png") no-repeat;
}
</style>

<style>
.el-main{
  padding:0px;
}
</style>